/**
 * Reverts full community profile links to relative links in post content.
 * Only affects links matching [@user](http(s)://domain/community/profiles/123).
 * @param {string} content
 * @returns {string}
 */
const revertProfileLinks = function(content) {
    if (!content) return content;

    // Regex matches [@user](http(s)://any-domain/community/profiles/xyz)
    const mentionRegex = /\[@([^\]]+)\]\(\s*https?:\/\/[^/]+\/community\/profiles\/([^)]+)\s*\)/g;

    return content.replace(
        mentionRegex,
        '[@$1](/community/profiles/$2)'
    );
};

module.exports = {
    revertProfileLinks
};